import { render, staticRenderFns } from "./AtomText.vue?vue&type=template&id=5c6ff851&"
import script from "./AtomText.vue?vue&type=script&lang=js&"
export * from "./AtomText.vue?vue&type=script&lang=js&"
import style0 from "./AtomText.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AtomText.vue"
export default component.exports